"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
const FirstPage_1 = __importDefault(require("@material-ui/icons/FirstPage"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const ChevronLeft_1 = __importDefault(require("@material-ui/icons/ChevronLeft"));
const ChevronRight_1 = __importDefault(require("@material-ui/icons/ChevronRight"));
const Select_1 = __importDefault(require("coact/inputs/Select"));
function PaginationView(props) {
    const pageNum = props.pageNum;
    const toFirstPage = () => props.setPageNum(1);
    const toPrevPage = () => props.setPageNum(Math.max(1, props.pageNum - 1));
    const toNextPage = () => props.setPageNum(props.pageNum + 1);
    const pageLimit = props.pageLimit;
    const onLimitChange = props.setPageLimit;
    const limitSchema = {
        label: '每頁筆數',
        options: [10, 50, 100, 250, 500, 1000],
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(IconButton_1.default, { onClick: toFirstPage },
            react_1.default.createElement(FirstPage_1.default, null)),
        react_1.default.createElement(IconButton_1.default, { onClick: toPrevPage },
            react_1.default.createElement(ChevronLeft_1.default, null)),
        react_1.default.createElement("div", { style: { display: 'inline-block' } },
            react_1.default.createElement(Typography_1.default, null, pageNum)),
        react_1.default.createElement(IconButton_1.default, { onClick: toNextPage },
            react_1.default.createElement(ChevronRight_1.default, null)),
        react_1.default.createElement("div", { style: { display: 'inline-block', width: 80 } },
            react_1.default.createElement(Select_1.default, { label: limitSchema.label, options: limitSchema.options, value: pageLimit, onChange: onLimitChange, onFocus: () => {
                }, onBlur: () => {
                }, startTyping: () => {
                }, updateTyping: () => {
                }, finishTyping: () => {
                }, setTypingDirty: () => {
                }, isTypingTextDirty: false, selectRef: () => {
                } }))));
}
exports.default = PaginationView;
